var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCashbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 123,
    viewBox: "0 0 123 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_201_2134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.267 192.341C171.144 192.341 196.175 167.31 196.175 136.433C196.175 105.556 171.144 80.5254 140.267 80.5254C109.39 80.5254 84.3594 105.556 84.3594 136.433C84.3594 167.31 109.39 192.341 140.267 192.341Z",
    fill: "#FA6700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1736 56.6753C41.4705 56.6753 49.0073 49.1385 49.0073 39.8416C49.0073 30.5445 41.4705 23.0078 32.1736 23.0078C22.8766 23.0078 15.3398 30.5445 15.3398 39.8416C15.3398 49.1385 22.8766 56.6753 32.1736 56.6753Z",
    fill: "#FA6700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.035 76.6906V115.036H46.0129V76.6906H115.035ZM122.704 69.0215H38.3438V122.705H122.704V69.0215Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5244 84.3605C86.8783 84.3605 92.0281 89.5104 92.0281 95.8642C92.0281 102.218 86.8783 107.368 80.5244 107.368C74.1705 107.368 69.0207 102.218 69.0207 95.8642C69.0207 89.5104 74.1705 84.3605 80.5244 84.3605ZM80.5244 76.6914C69.9525 76.6914 61.3516 85.2923 61.3516 95.8642C61.3516 106.436 69.9525 115.037 80.5244 115.037C91.0963 115.037 99.6972 106.436 99.6972 95.8642C99.6972 85.2923 91.0963 76.6914 80.5244 76.6914Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3604 15.3383V11.5037C84.3604 3.06765 77.4966 0 72.8567 0H34.5111C26.075 0 23.0074 6.86387 23.0074 11.5037V15.3383H0V92.0296H30.6765V84.3604H7.66913V46.0148H23.0074V53.6839H30.6765V46.0148H76.6913V53.6839H84.3604V46.0148H99.6987V61.353H107.368V15.3383H84.3604ZM30.6765 11.542C30.7149 9.77814 31.4051 7.66913 34.5111 7.66913H72.8184C74.5823 7.70748 76.6913 8.3977 76.6913 11.5037V15.3383H30.6765V11.542ZM99.6987 38.3456H84.3604V30.6765H76.6913V38.3456H30.6765V30.6765H23.0074V38.3456H7.66913V23.0074H99.6987V38.3456Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_201_2134"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 122.706,
    height: 122.706,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashbox);
export default __webpack_public_path__ + "static/media/Cashbox.69a9c0e5251d745cd186efc8649d4fd0.svg";
export { ForwardRef as ReactComponent };